import React, { FC } from 'react';

import * as Styled from './Tag.styles';
import { useParams } from 'react-router-dom';
import { renderHttpRemoteData } from '@shared/utils/render';
import TagHeader from '@modules/visits/components/tag/header/TagHeader';
import TagDescription from '@modules/visits/components/tag/description/TagDescription';
import TagSlice from './slice/TagSlice';
import { useTag } from '@modules/visits/context';
import { PrismicGoogleMapsSlice } from '@modules/visits/model';

const Tag: FC = () => {
  const { tagId } = useParams<'tagId'>() as { tagId: string };

  const tag = useTag(tagId);

  return renderHttpRemoteData(tag, ({ tag: { data }, related }) => {
    const slices = [...(data?.body ?? [])];
    
    const googleMapsSlices = slices.filter(
      (slice): slice is PrismicGoogleMapsSlice => slice.slice_type === 'app_google_maps'
    );

    const otherSlices = slices.filter(
      slice => slice.slice_type !== 'app_google_maps'
    );

    return (
      <Styled.TagContainer>
        <TagHeader tag={data} />
        <TagDescription tag={data} related={related} googleMapsSlices={googleMapsSlices} />

        {otherSlices.map((slice, i) => (
          <TagSlice key={i} slice={slice} />
        ))}
      </Styled.TagContainer>
    );
  });
};

export default Tag;
